import router from "@/router/index";

export const alertStore = {
  namespace: false,
  state: { msg: "", sCb: null, fCb: null, type: null, show: false },
  getters: {
    getAlert(state: any) {
      return state;
    },
    getAlertStatus(state: any) {
      return state.show;
    },
  },
  mutations: {
    alert(state: any, data: any) {
      state.title = data.title;
      state.msg = data.msg;
      state.sCb = data.sCb;
      state.fCb = undefined;
      state.type = "alert";
      state.show = true;
    },
    confirm(state: any, data: any) {
      state.title = data.title;
      state.msg = data.msg;
      state.sCb = data.sCb;
      state.fCb = data.fCb;
      state.type = "confirm";
      state.show = true;
    },
    closeAlert(state: any) {
      state.show = false;
    },
  },
};
export default alertStore;
